export default __webpack_public_path__ + "static/media/app-store.82c4965c.svg";